import { CustomerInfoView } from "@tiny/api";
import { DataTableColumn } from "@tiny/components/src/DataTable/DataTable.types";
import { ChipColor } from "@tiny/components/src/Chip/Chip.types";
import {
  SubscriberColumn,
  SubscriberColumnId,
  SubscriberColumnView,
} from "./SubscribersTable.types";

export function getChipColor(status: string): ChipColor {
  switch (status) {
    default:
      return "grey";
  }
}

export const subscribersColumns: SubscriberColumn[] = [
  {
    id: "email",
    name: "Email address",
  },
  {
    id: "status",
    name: "Status",
  },
  {
    id: "firstName",
    name: "First name",
  },
  {
    id: "lastName",
    name: "Last name",
  },
  {
    id: "send",
    name: "Sent",
  },
  {
    id: "delivered",
    name: "Delivered",
  },
  {
    id: "open",
    name: "Opened",
  },
  {
    id: "clicked",
    name: "Clicked",
  },
  {
    id: "updatedAt",
    name: "Updated date",
  },
  {
    id: "source",
    name: "Source",
  },
  {
    id: "birthday",
    name: "Birthday",
  },
  {
    id: "tags",
    name: "Tags",
  },
  {
    id: "currency",
    name: "Currency",
  },
  {
    id: "country",
    name: "Country",
  },
  {
    id: "province",
    name: "State/Province",
  },
  {
    id: "city",
    name: "City",
  },
  {
    id: "address1",
    name: "Address 1",
  },
  {
    id: "address2",
    name: "Address 2",
  },
  {
    id: "phone",
    name: "Phone number",
  },
  {
    id: "postalCode",
    name: "Zip/Postal Code",
  },
  {
    id: "company",
    name: "Company",
  },
  {
    id: "ordersCount",
    name: "Number of orders",
  },
  {
    id: "totalSpent",
    name: "Lifetime value",
  },
  {
    id: "lastOrderId",
    name: "Latest order ID",
  },
  {
    id: "lastOrderName",
    name: "Last purchased order",
  },
  {
    id: "lastOrderDate",
    name: "Last purchased date",
  },
  {
    id: "lastOrderPrice",
    name: "Last purchased price",
  },
  {
    id: "utm",
    name: "UTM",
  },
];

export const visibleColumnsDefault: SubscriberColumnId[] = [
  "email",
  "status",
  "firstName",
  "lastName",
  "updatedAt",
  "send",
  "delivered",
  "open",
  "clicked",
];

export function subscribersColumnsToDataTableColumns(
  subscriberColumnView: SubscriberColumnView[],
  visibleColumns: string[]
) {
  const visibleSubscribersColumns = subscribersColumns.filter(({ id }) => {
    return visibleColumns.includes(id);
  });
  return visibleSubscribersColumns.map<DataTableColumn<CustomerInfoView>>(
    (col) => {
      const columnView = subscriberColumnView.find(({ id }) => id === col.id);
      if (columnView) {
        return {
          header: col.name,
          renderBody: columnView.renderBody,
          cellProps: columnView.cellProps,
          useBodyWrapper: columnView.useBodyWrapper,
        } as DataTableColumn<CustomerInfoView>;
      }
      return {
        header: col.name,
        renderBody: (item: CustomerInfoView) => item[col.id] as never,
      };
    }
  );
}

export const uncheckableColumns: SubscriberColumnId[] = [
  "email",
  "firstName",
  "lastName",
  "updatedAt",
];
